exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".google-btn[data-v-8e4be9bc]{height:50px;background-color:#4285f4;border-radius:2px;margin-bottom:12px;cursor:pointer}.google-btn .google-icon-wrapper[data-v-8e4be9bc]{position:absolute;margin-top:1px;margin-left:1px;width:48px;height:48px;border-radius:2px;background-color:#fff}.google-btn .google-icon[data-v-8e4be9bc]{position:absolute;margin-top:11px;margin-left:-12px;width:26px;height:26px}.google-btn .btn-text[data-v-8e4be9bc]{float:left;margin:10px 11px 0 67px;color:#fff;font-size:18px;letter-spacing:.2px}.google-btn[data-v-8e4be9bc]:hover{box-shadow:0 0 6px #4285f4}.google-btn[data-v-8e4be9bc]:active{background:#1669f2}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8e4be9bc","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/core/Login.vue
// module id = 383
// module chunks = 0